import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  RadioGroupProps,
} from '@mui/material';
import { ReactNode } from 'react';
import { Control, Controller } from 'react-hook-form';

export type InputCheckboxProps = RadioGroupProps & {
  name: string;
  control: Control<any>;
  label?: ReactNode;
  helperText?: ReactNode;
};

export const InputCheckbox = (props: InputCheckboxProps) => {
  const { name, control, label, helperText, ...restProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={restProps.defaultValue}
      render={({ field, fieldState }) => {
        return (
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={Boolean(field.value)}
                  id={name}
                  className="text-primary"
                />
              }
              label={label}
              className="mr-0"
            />
            <FormHelperText
              className="pl-md text-error"
              error={Boolean(fieldState.error)}
            >
              {fieldState.error?.message || helperText}
            </FormHelperText>
          </div>
        );
      }}
    />
  );
};
